// =====================================
//
//   float bar
//   Author: Gray
//   createtime: 2016 / 02 / 22
//   updatetime: 2016 / 02 / 22
//
// =====================================

window.InifECApp.directive('floatBar', ['$rootScope', 'ShoppingCartService', '$state', function($rootScope, ShoppingCartService, $state) {

	var _dir = {};

    var link = function(scope, element, attrs) {

        var $window = $(window);
        var scrollHandler = function(event) {
            var scrollTop = $window.scrollTop();
            if (scope.$$phase) {
                return scope.$eval(function() {
                    if(scrollTop > 0) {
                        scope.isShowScrollTopButton = true;
                    } else {
                        scope.isShowScrollTopButton = false;
                    }
                });
            } else {
                return scope.$apply(function() {
                    if(scrollTop > 0) {
                        scope.isShowScrollTopButton = true;
                    } else {
                        scope.isShowScrollTopButton = false;
                    }
                });
            }
        }

        var scrollToTop = function(scrollDuration) {

            const   scrollHeight = $window.scrollTop(),
                    scrollStep = Math.PI / Math.ceil( scrollDuration / 15 ),
                    cosParameter = scrollHeight / 2;
            var     scrollCount = 0,
                    scrollMargin;

            requestAnimationFrame(step);

            function step () {
                setTimeout(function() {
                    if ( window.scrollY != 0 ) {
                            requestAnimationFrame(step);
                        scrollCount = scrollCount + 1;  
                        scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );
                        window.scrollTo( 0, ( scrollHeight - scrollMargin ) );
                    }
                }, 15 );
            }
        }

        element.find('.to-top').bind('click', function(){
            // $window.scrollTop(0);
            scrollToTop(100);
        });
        
        $window.bind('scroll', throttle(scrollHandler));
    }

	var controller = ['$scope', function($scope) {
        
        var getAllCartTotalAmount = function() {

            if(ShoppingCartService.checkAllCartHasOfferProcess()) {
                return "待報價";
            }

            return "$" + ShoppingCartService.getAllCartTotalAmount();
        }

        var getAllCartShoppingCartItemSize = function() {

            return ShoppingCartService.getAllCartShoppingCartItemSize();
        }

    	var init = function() {
            
            $scope.state = $state.current.name;

            $scope.isCart = $scope.state == window.STATES.CART;
    	}

        //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
            $scope.state = $state.current.name;

            $scope.isCart = $scope.state == window.STATES.CART;
        });

        //==========================
        //  Members
        //==========================
        $scope.isShowScrollTopButton = false;
        $scope.isCart = false;

        //==========================
        //  Methods
        //==========================        
        $scope.getAllCartShoppingCartItemSize = getAllCartShoppingCartItemSize;
        $scope.getAllCartTotalAmount = getAllCartTotalAmount;

        //==========================
        //  Init
        //==========================
        init();

	}];

	_dir.restrict = 'E';
	_dir.scope = true;
    _dir.link = link;
	_dir.templateUrl = "partials/directives/float_bar.html";
	_dir.controller = controller;

	return _dir;

}]);
